import React from 'react';
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";

const ParticleDark = () => {
  const particlesInit = async (main) => {
    await loadFull(main);
  };

  const particlesLoaded = (container) => {
    console.log(container);
  }

  return (
    <div>
       <Particles
      id="tsparticles"
      init={particlesInit}
      loaded={particlesLoaded}
      params={{
        selector : "#tsparticles",
        backgroundMode: {
          enable: true,
          zIndex: -1,
        },
        backgroundMask: {
          composite: "destination-out",
          cover: {

            color: {
              value: "#1f1f38",
            },
          },
          enable: true,
        },
        background: {
          color: {
            value: "#4db5ff",
          },
        },
        fpsLimit: 120,
        particles: {
          color: {
            value: "#ffffff",
          },
          links: {
            color: "rgba(255, 255, 255, 0.6)",
            distance: 200,
            enable: true,
            opacity: 0.5,
            width: 1,
          },
          collisions: {
            enable: true,
          },
          move: {
            direction: "none",
            enable: true,
            outMode: "bounce",
            random: false,
            speed: 0.5,
            straight: true,
          },
          number: {
            density: {
              enable: true,
              value_area: 500,
            },
            value: 80,
          },
          opacity: {
            value: 0.5,
          },
          shape: {
            type: "data",
          },
          size: {
            random: true,
            value: 4,
          },
        },
        events: {
          onHover: {
            enable: true,
            mode: "bubble",
          },
          resize: true,
        },
        modes: {
          bubble: {
            distance: 250,
            duration: 2,
            opacity: 0,
            size: 0,
            speed: 3,
          },
          push: {
            quantity: 4,
          },
          repulse: {
            distance: 400,
            duration: 0.4,
          },
        },
        
        
        // Responsive Background Color
        responsive: [
          {
            maxWidth: 1024,
            options: {
              particles: {
                number:{
                  density: {
                    value_area: 700,
                  },
                  value: 80,
                },
                size: {
                  value: 3,
                },
              },
            },
          },
          {
            maxWidth: 600,
            options: {
              particles: {
                number: {
                  density: {
                    value_area: 800,
                  },
                  value: 80,
                },
                size: {
                  value: 2,
                },
              },
            },
          },
        ],
        detectRetina: true,
      }}
    />
    </div>
  )
}

export default ParticleDark;
